import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import './App.css'
import { Route, Link,  Router, Switch, Redirect } from 'react-router-dom'
import Chat from './components/chat/Chat'
import Notfound from './components/404'
import UserList from './components/chat/UserList'
import Users from './components/users'
import Login from './components/login'
import Profile from './components/Profile'
import Contact from './components/contact'
import Home from './components/Home'
import ArticlePage from './components/ArticlePage'
import Quiz from './components/quiz/Quiz'
import ConsultRequests from './components/consult/ConsultRequests'
// import Quiz from './components/consult/Quiz'
import ConsultHistory from './components/consult/ConsultHistory'
import { BaseUrl } from './settings'
import Matrix from './scripts/Matrix'
import NewConsult from './components/consult/NewConsult'
import ReactGA from 'react-ga';
// import { createBrowserHistory } from 'history';
import history from './history';
import Intro from './components/Intro'
import Hint from './components/hint'

// import ItineraryMaker from './components/calendar'

function initializeReactGA() {
  // console.log('initializing GA -------------------------')
  ReactGA.initialize('UA-109009253-1');
  ReactGA.pageview(window.location.pathname + window.location.search);
}

initializeReactGA()


// Initialize google analytics page view tracking
history.listen(location => {
  // console.log('here in history listener ------------', location)
  ReactGA.pageview(location.pathname + location.search);
});



const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    Matrix.isLoggedIn() === true
      ? <Component {...props} />
      : <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }} />
  )} />
)

const App = () => {

  let [introShow, setIntroShow] = useState(localStorage.getItem('introShow') === 'true')
  console.log(localStorage.getItem('introShow'))
  console.log(localStorage.getItem('introShow') === 'true')
  console.log(introShow)

  const setIntro = (val) => {
    console.log('----------', val)
    localStorage.setItem('introShow',val)
    setIntroShow(val)
    console.log(introShow)

}

  return (
    <Router history={history}>
      <div class="root-new">
        {!introShow &&
          // <Hint setIntroShow={setIntro}></Hint>
          <Intro setIntroShow={setIntro}></Intro>
        }
        <Switch>

          <Route path={"/login"} component={Login} />
          {/* <Route path={"/home"} component={Home} /> */}
          <Route path={"/test"} component={Quiz} />
          <Route path={"/article/:id"} component={ArticlePage} />
          <Route path={"/contact"} component={Contact} />
          {/* <Route path={BaseUrl + "/addtodo"} component={AddToDo} /> */}
          {/* <Route path={BaseUrl + "/it/:id/"} component={AsyncComponent} />  */}
          <PrivateRoute path={"/consult/new"} component={NewConsult} />
          <PrivateRoute path={"/chat/:id/"} component={Chat} />
          <PrivateRoute path={"/chats"} component={UserList} />
          {/* <PrivateRoute path={"/consults"} component={ConsultRequests} /> */}
          <PrivateRoute path={"/profile"} component={Profile} />
          {/* <PrivateRoute path={"/quiz/:id"} component={Quiz} /> */}
          <PrivateRoute path={"/consultHistory/:consultRequestId"} component={ConsultHistory} />

          <PrivateRoute path={"/"} component={UserList} />
          <Route component={Notfound} />
        </Switch>

      </div>
    </Router>
  );
}

export default App;